import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { 
  SearchSubscriptionOverlayComponent, 
  SEARCH_SUBSCRIPTION_OVERLAY_ORIGIN,
  SearchSubscriptionOverlayOrigin
 } from '../search-subscription-overlay/search-subscription-overlay.component';
import { ComponentPortal } from '@angular/cdk/portal';

@Component({
  selector: 'app-search-subscription-button',
  templateUrl: './search-subscription-button.component.html',
  styleUrls: ['./search-subscription-button.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSubscriptionButtonComponent {
  overlayRef!: OverlayRef;

  @Input()
  origin!: SearchSubscriptionOverlayOrigin;

  constructor(private overlay: Overlay) {}

  open() {
    this.createOverlay();
  }

  private createOverlay() {
    const positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .top('80px');
    const scrollStrategy = this.overlay.scrollStrategies.block();

    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      positionStrategy,
      scrollStrategy,
    });

    const injector = Injector.create({
      providers: [
        {
          provide: OverlayRef,
          useValue: this.overlayRef,
        },
        {
          provide: SEARCH_SUBSCRIPTION_OVERLAY_ORIGIN,
          useValue: this.origin,
        },
      ],
    });
    const portal = new ComponentPortal(
      SearchSubscriptionOverlayComponent,
      null,
      injector
    );

    this.overlayRef.attach(portal);

    this.overlayRef.backdropClick().subscribe(() => {
      this.close();
    });

    this.overlayRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.code === 'Escape') {
        this.close();
      }
    });
  }

  close() {
    this.overlayRef.dispose();
  }
}
